define('common/jquery/config',['require','exports','module'],function(require, exports, module) {
  "use strict";

  var config = {
    availableVersions: [
      {
        name: 'Latest jQuery 3.x (3.6.0)',
        version: '3.6.0',
        url: 'https://code.jquery.com/jquery-3.6.0.min.js'
      },
      {
        name: 'Latest jQuery 2.x (2.2.4)',
        version: '2.2.4',
        url: 'https://code.jquery.com/jquery-2.2.4.min.js'
      },
      {
        name: 'Latest jQuery 1.x (1.12.4)',
        version: '1.12.4',
        url: 'https://code.jquery.com/jquery-1.12.4.min.js'
      },
      {
        name: 'Latest jQuery Migrate (3.3.2)',
        version: 'migrate',
        url: 'https://code.jquery.com/jquery-migrate-3.3.2.min.js'
      },
    ],

    getLatest: function () {
      return this.availableVersions[0];
    },

    getURLByVersion: function(version) {

      var latest = this.availableVersions.find(function (group) {return group.version === version;}) || this.getLatest();

      return latest.url;
    }
  };

  module.exports = config;
});

